export default "__VITE_ASSET__93e63d8c__"